"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyItems: 'flex-start'
    },
    chips: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexWrap: 'wrap',
      marginTop: theme.spacing(2),
      paddingRight: theme.spacing(11),
      position: 'relative',
      width: '100%'
    },
    chip: (0, _defineProperty2.default)({
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5)
    }, theme.breakpoints.down('xs'), {
      height: 'auto',
      '& >span': {
        overflow: 'unset',
        whiteSpace: 'normal',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
      }
    }),
    button: {
      position: 'absolute',
      right: 0,
      top: theme.spacing(0.5)
    },
    reset: {
      marginRight: theme.spacing(2),
      borderRadius: theme.spacing(2),
      borderColor: theme.palette.primary.main,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
      textTransform: 'none',
      fontWeight: 400,
      '&:hover': {
        backgroundColor: 'rgba(206, 31, 36, 0.04)',
        borderColor: theme.palette.primary.main
      }
    },
    condition: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      position: 'relative',
      paddingRight: 313,
      minHeight: theme.spacing(10)
    },
    total: {
      marginRight: theme.spacing(3)
    }
  };
}, {
  name: 'SelectMultipleFilter'
});

var mapFilterToState = function mapFilterToState(_ref) {
  var price = _ref.price,
      _ref$parameters = _ref.parameters,
      parameters = _ref$parameters === void 0 ? {} : _ref$parameters;
  return price ? (0, _extends3.default)({
    price: price
  }, parameters) : (0, _extends3.default)({}, parameters);
};

function SelectMultipleFilter(_ref2) {
  var buildFilter = _ref2.buildFilter,
      children = _ref2.children,
      chipColor = _ref2.chipColor,
      pClasses = _ref2.classes,
      className = _ref2.className,
      currency = _ref2.currency,
      filter = _ref2.filter,
      filterHash = _ref2.filterHash,
      onChange = _ref2.onChange,
      parentFilter = _ref2.parentFilter,
      resetFilter = _ref2.resetFilter,
      total = _ref2.total,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["buildFilter", "children", "chipColor", "classes", "className", "currency", "filter", "filterHash", "onChange", "parentFilter", "resetFilter", "total"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();

  var _React$useState = _react.default.useState(mapFilterToState(filter)),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      filterValue = _React$useState2[0],
      setFilterValue = _React$useState2[1];

  var handleChange = _react.default.useCallback(function (_ref3) {
    var field = _ref3.field,
        value = _ref3.value;
    return setFilterValue(function (pf) {
      return (0, _extends3.default)({}, pf, (0, _defineProperty2.default)({}, field, value));
    });
  }, []);

  var handleSubmitFilter = _react.default.useCallback(function () {
    if (onChange) {
      // parameters should be one filter field
      var price = filterValue.price,
          parameters = (0, _objectWithoutProperties2.default)(filterValue, ["price"]);
      onChange({
        price: price,
        parameters: parameters
      });
    }
  }, [filterValue, onChange]);

  var handleResetFilter = _react.default.useCallback(function () {
    setFilterValue({});

    if (resetFilter) {
      resetFilter();
    }
  }, [resetFilter]);

  var fields = _react.default.Children.map(children, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      onChange: handleChange,
      filter: filter,
      filterValue: filterValue,
      mode: 'field',
      parentFilter: parentFilter,
      buildFilter: buildFilter
    });
  });

  var values = _react.default.Children.map(children, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      onChange: handleChange,
      filter: filter,
      filterValue: filterValue,
      mode: 'value',
      parentFilter: parentFilter,
      buildFilter: buildFilter,
      className: classes.chip,
      chipColor: chipColor
    });
  });

  _react.default.useEffect(function () {
    return setFilterValue(mapFilterToState(filter));
  }, [filter, filterHash]);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends3.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.condition
  }, fields), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.chips
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.total
  }, t('selectMultipleFilter/totalChipsLabel', {
    total: total
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: handleResetFilter,
    className: classes.reset,
    variant: "outlined"
  }, t('productListOrderSelectorButton/resetFilter')), values, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: handleSubmitFilter,
    className: classes.button,
    variant: "contained"
  }, t('productListOrderSelectorButton/ok'))));
}

process.env.NODE_ENV !== "production" ? SelectMultipleFilter.propTypes = {
  buildFilter: _propTypes.default.func.isRequired,
  children: _propTypes.default.node,
  chipColor: _propTypes.default.oneOf(['primary', 'secondary', 'default']),
  classes: _propTypes.default.shape({
    button: _propTypes.default.string,
    chip: _propTypes.default.string,
    chips: _propTypes.default.string,
    condition: _propTypes.default.string,
    reset: _propTypes.default.string,
    root: _propTypes.default.string,
    total: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  currency: _propTypes.default.string.isRequired,
  filter: _propTypes.default.shape({
    parameters: _propTypes.default.shape({}),
    price: _propTypes.default.arrayOf(_propTypes.default.number)
  }).isRequired,
  // reset filter if thic value changes
  filterHash: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.shape({}), _propTypes.default.string]),
  onChange: _propTypes.default.func,
  onDelete: _propTypes.default.func,
  parentFilter: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.arrayOf(_propTypes.default.shape({}))]),
  resetFilter: _propTypes.default.func,
  total: _propTypes.default.number
} : void 0;
SelectMultipleFilter.defaultProps = {
  children: null,
  chipColor: 'secondary',
  classes: undefined,
  className: undefined,
  filterHash: undefined,
  onChange: undefined,
  onDelete: undefined,
  parentFilter: undefined,
  resetFilter: undefined,
  total: undefined
};
var _default = SelectMultipleFilter;
exports.default = _default;